module.exports = __webpack_public_path__ + "img/purple.c0c44544.png";